import styled from 'styled-components';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import { Button } from 'src/components/button';

export const FeatureList = styled.ul`
  list-style: none;
  margin: 10px 0 20px 0;
`;

export const FeatureListItem = styled.li`
  padding: 10px;
`;

export const FeatureListCheckIcon = styled(CheckCircleIcon).attrs(() => ({
  size: '16px',
}))`
  fill: ${p => p.theme.colors.positive500};
  vertical-align: middle;
  margin-right: 0.5em;
`;

export const SignInButton = styled(Button).attrs({
  color: 'positive',
  'data-test': 'SignInButton',
})`
  width: 100%;
`;

export const CreateAccountButton = styled(Button).attrs({
  variant: 'text',
  color: 'link',
  'data-test': 'CreateAccountButton',
})`
  margin-top: 10px;
  width: 100%;
`;
